import { ComponentType } from 'react';

import { CustomFieldAttribute } from 'apis/customFields';

import { OptionsFormField, PlaceholderFormField } from '../components/fields';

/**
 * Represents various attributes of attribute types in the custom attribute
 * form.
 */
export const attributeTypeFormAttributes: {
  readonly [TCustomFieldAttribute in CustomFieldAttribute as TCustomFieldAttribute['type']]: TCustomFieldAttribute extends {
    [TCustomFieldAttributeType in keyof TCustomFieldAttribute]: TCustomFieldAttribute[TCustomFieldAttributeType];
  }
    ? Pick<TCustomFieldAttribute, 'data_type'> & {
        /** The attribute label. */
        readonly label: string;
        /** Whether the attribute is disabled. */
        readonly isDisabled: boolean;
        /** The form fields. */
        readonly fields: readonly ComponentType[];
      }
    : never;
} = {
  text: {
    label: 'Text',
    data_type: 'string',
    isDisabled: false,
    fields: [PlaceholderFormField],
  },
  select: {
    label: 'Select',
    data_type: 'string_set',
    isDisabled: false,
    fields: [OptionsFormField],
  },
};
